import React from 'react';
import SelectedIntents from './selectedIntents.jsx';
import IntentsSelector from './intentsSelector.jsx';
import CmsService from '../js/cmsService.js';
import * as constants from '../js/constants.js';

let cmsService = new CmsService();

class IntentGateHeader extends React.Component {

  componentDidMount() {
  }

  handleBreadcrumbClicked = () => {
    this.props.onPageChanged(constants.PROJECTS_PAGE);
  }

  handleSkipLink = () => {
    this.props.onSkip();
  }

  getBreadcrumbContent() {
    if (this.props.currentPage === constants.PROJECTS_PAGE) {
      return (
          <span className='breadcrumb-text'>{this.props.content.dataProjectType}</span>
      );
    } else if (this.props.currentPage === constants.SOURCES_PAGE) {
      var separator = ">";
      return (
          <div>
            <a className='breadcrumb-link' onClick={this.handleBreadcrumbClicked}>{this.props.content.dataProjectType}</a>
            <span className='breadcrumb-separator'>{separator}</span>
            <span className='breadcrumb-text'>{this.props.content.sourceTargetType}</span>
          </div>
      );
    }
  }

  render() {
    return (
      <div className='intent-gate-header'>
        <div className='use-cases-header-top'>
          {this.getBreadcrumbContent()}
          <a className='skip-link'
            onClick={this.handleSkipLink}>{ this.props.content.skipTutorial }</a>
        </div>
      </div>
    );
  }
}

export default IntentGateHeader;


